import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Map, List } from 'lucide-react';

export const MapListToggle: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const isMapView = location.pathname === '/map-campaign';
  
  const handleToggle = () => {
    if (isMapView) {
      navigate('/');
    } else {
      navigate('/map-campaign');
    }
  };
  
  return (
    <div className="fixed bottom-[5%] left-1/2 transform -translate-x-1/2 z-50">
      <button
        onClick={handleToggle}
        className="flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-gray-700 px-6 py-3 rounded-full shadow-md hover:shadow-lg transition-all border border-gray-200 min-w-[120px] font-medium"
        aria-label={isMapView ? '목록 보기' : '지도 보기'}
      >
        {isMapView ? (
          <>
            <List size={20} className="flex-shrink-0" />
            <span className="text-sm font-medium">목록보기</span>
          </>
        ) : (
          <>
            <Map size={20} className="flex-shrink-0" />
            <span className="text-sm font-medium">지도보기</span>
          </>
        )}
      </button>
    </div>
  );
};

export default MapListToggle;